import { Fragment } from "react";

export const ImagesCollection = (props: any) => {
  const { gallery } = props;
  return (
    <div className="container mx-auto">
      <div className="flex flex-wrap -m-1 md:-m-2">
        {gallery.map((image: any, index: number) => {
          return (
            <Fragment key={index}>
              {gallery.length === 1 && (
                <div className="flex flex-wrap w-full">
                  <div className="w-full p-1 md:p-2">
                    <img
                      alt="gallery"
                      className="block object-cover object-center w-full h-full rounded-lg"
                      src={image.FileRef}
                    />
                  </div>
                </div>
              )}
              {gallery.length === 2 && (
                <div className="flex flex-wrap w-1/2">
                  <div className="w-full p-1 md:p-2">
                    <img
                      alt="gallery"
                      className="block object-cover object-center w-full h-full rounded-lg"
                      src={image.FileRef}
                    />
                  </div>
                </div>
              )}
              {gallery.length >= 3 && (
                <div className="flex flex-wrap w-1/3">
                  <div className="w-full p-1 md:p-2">
                    <img
                      alt="gallery"
                      className="block object-cover object-center w-full h-full rounded-lg"
                      src={image.FileRef}
                    />
                  </div>
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ImagesCollection;
